import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

export const MY_CARD_PATH = "/ma-carte";

const MyCardPage = lazyWithRetry(() => import("@/features/card/pages/MyCardPage"));

const cardRoutes: RouteConfig[] = [
  {
    path: MY_CARD_PATH,
    element: <MyCardPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default cardRoutes;
